  // export const IPUrl ="http://192.168.100.110:8100/";
 //export const IPUrl ="http://192.168.100.55:7003/";
// export const IPUrl ="https://portalcity.myamol.ir/";
export const IPUrl = !process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? "http://192.168.100.55:7003/" : "https://portalcity.myamol.ir/"